import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {
    SelectInput,
} from 'admin-on-rest';
import {
    convertDate,
} from '../shared/functions';
import {
    HOURS_24,
    MINUTES,
    TIME_ZONE_OFFSETS
} from '../shared/dateTimeLists';
import FormattedDateTextInput from './FormattedDateTextInput';
import {filterStyles} from '../shared/styles-filter';

/**
 * A form containing a SelectInput component with Mode choices
 *
 */
class DateRangeTimeFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayDateFilter: false,
            selectedStartDate: null,
            selectedStartDateObject: null,
            selectedStartHour: '00',
            selectedStartMin: '00',
            selectedEndDate: null,
            selectedEndHour: '23',
            selectedEndMin: '59',
            selectedOffset: (props.selectedOffset) ? props.selectedOffset : null,
        };
        this.handleStartDateSelect = this.handleStartDateSelect.bind(this);
        this.handleStartHourSelect = this.handleStartHourSelect.bind(this);
        this.handleStartMinSelect = this.handleStartMinSelect.bind(this);
        this.handleEndDateSelect = this.handleEndDateSelect.bind(this);
        this.handleEndHourSelect = this.handleEndHourSelect.bind(this);
        this.handleEndMinSelect = this.handleEndMinSelect.bind(this);
        this.handleOffsetSelect = this.handleOffsetSelect.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(change('filterForm', 'start_hour', this.state.selectedStartHour));
        this.props.dispatch(change('filterForm', 'start_min', this.state.selectedStartMin));
        this.props.dispatch(change('filterForm', 'end_hour', this.state.selectedEndHour));
        this.props.dispatch(change('filterForm', 'end_min', this.state.selectedEndMin));
        this.props.onSelectStartTime('start_time', this.state.selectedStartHour + ':' + this.state.selectedStartMin);
        this.props.onSelectEndTime('end_time', this.state.selectedEndHour + ':' + this.state.selectedEndMin);
    }

    /* Selection Processing ------------------------------ */

    /**
     * Handle selection event for Start Date
     *
     * @param event
     * @param index
     * @param value
     */
    handleStartDateSelect(event, index, value) {
        if (index && index !== value) {
            // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
            const dateStr = convertDate(index, 'query', false, true);
            const dateYear = new Date(index).getFullYear();
            if (dateYear && dateYear > 2015) {
                this.setState({
                        selectedStartDate: dateStr,
                        selectedStartDateObject: index,
                        selectedEndDate: null,
                    },
                    () => {
                        this.props.dispatch(change('filterForm', 'start_date', dateStr));
                        this.props.onSelectStartDate('start_date', dateStr);
                    }
                );
            }
        }
    }

    handleStartHourSelect(event, index, value) {
        if (index && index !== value) {
            this.setState({
                    selectedStartHour: index
                },
                () => {
                    this.props.dispatch(change('filterForm', 'start_hour', index));
                    this.assembleStartTime();
                });
        }
    }

    handleStartMinSelect(event, index, value) {
        if (index && index !== value) {
            this.setState({
                    selectedStartMin: index
                },
                () => {
                    this.props.dispatch(change('filterForm', 'start_min', index));
                    this.assembleStartTime();
                });
        }
    }

    assembleStartTime() {
        let hour = this.state.selectedStartHour;
        let min = this.state.selectedStartMin;

        if (hour && min) {
            let startTime = hour + ':' + min;
            this.props.onSelectStartTime('start_time', startTime);
        }
    }

    /**
     * Handle selection event for End Date
     *
     * @param event
     * @param index
     * @param value
     */
    handleEndDateSelect(event, index, value) {
        if (index && index !== value) {
            // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
            const dateStr = convertDate(index, 'query', false, true);
            const dateYear = new Date(index).getFullYear();
            if (dateYear && dateYear > 2015) {
                this.setState({
                        selectedEndDate: dateStr
                    },
                    () => {
                        this.props.dispatch(change('filterForm', 'end_date', dateStr));
                        this.props.onSelectStartDate('end_date', dateStr);
                    }
                );
            }
        }
    }

    handleEndHourSelect(event, index, value) {
        if (index && index !== value) {
            this.setState({
                    selectedEndHour: index
                },
                () => {
                    this.props.dispatch(change('filterForm', 'end_hour', index));
                    this.assembleEndTime();
                });
        }
    }

    handleEndMinSelect(event, index, value) {
        if (index && index !== value) {
            this.setState({
                    selectedEndMin: index
                },
                () => {
                    this.props.dispatch(change('filterForm', 'end_min', index));
                    this.assembleEndTime();
                });
        }
    }

    assembleEndTime() {
        let hour = this.state.selectedEndHour;
        let min = this.state.selectedEndMin;

        if (hour && min) {
            let endTime = hour + ':' + min;
            this.props.onSelectEndTime('end_time', endTime);
        }
    }

    /**
     * Handle selection event for Time Zone Offset
     *
     * @param event
     * @param index
     * @param value
     */
    handleOffsetSelect(event, index, value) {
        if (index && index !== value) {
            this.setState({
                    selectedOffset: index
                },
                () => {
                    this.props.dispatch(change('filterForm', 'offset', index));
                    this.props.onSelectOffset('offset', index);
                });
        }
    }

    render() {
        const {
            selectedOffset
        } = this.props;

        return (
            <form>
                <div className="list-filter">
                    <div style={filterStyles.filterRow}>
                        <FormattedDateTextInput
                            name="start_date"
                            source="start_date"
                            label="Select a Start Date:"
                            onChangeFunc={this.handleStartDateSelect}
                            maxDate={new Date()}
                        />
                        <Field name="start_hour"
                               component={SelectInput}
                               label="Hour"
                               choices={HOURS_24}
                               onChange={this.handleStartHourSelect}
                               elStyle={filterStyles.selectInputSmall}
                        />
                        <Field name="start_min"
                               component={SelectInput}
                               label="Min"
                               choices={MINUTES}
                               onChange={this.handleStartMinSelect}
                               elStyle={filterStyles.selectInputSmall}
                        />
                    </div>
                    <div style={filterStyles.filterRow}>
                        <FormattedDateTextInput
                            name="end_date"
                            source="end_date"
                            label="Select a End Date:"
                            onChangeFunc={this.handleEndDateSelect}
                            maxDate={new Date()}
                            isDisabled={!this.state.selectedStartDateObject}
                        />
                        <Field name="end_hour"
                               component={SelectInput}
                               label="Hour"
                               choices={HOURS_24}
                               onChange={this.handleEndHourSelect}
                               elStyle={filterStyles.selectInputSmall}
                        />
                        <Field name="end_min"
                               component={SelectInput}
                               label="Min"
                               choices={MINUTES}
                               onChange={this.handleEndMinSelect}
                               elStyle={filterStyles.selectInputSmall}
                        />
                    </div>
                    <hr style={filterStyles.break}/>

                    <Field name="offset"
                           component={SelectInput}
                           label="Select a Time Zone Offset"
                           choices={TIME_ZONE_OFFSETS}
                           onChange={this.handleOffsetSelect}
                           elStyle={filterStyles.selectInput}
                           options={{
                               value: selectedOffset
                           }}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let filterForm = state.form['filterForm'];
    let timeZoneForm = state.form['timeZoneForm'];
    const defaultOffsetValue = (timeZoneForm && timeZoneForm.values && timeZoneForm.values['timeZoneDefault']) ? timeZoneForm.values['timeZoneDefault'] : null;
    if (filterForm && filterForm.values) {
        const startDateValue = (filterForm.values['start_date']) ? filterForm.values['start_date'].toString() : null;
        const startHourValue = (filterForm.values['start_hour']) ? filterForm.values['start_hour'].toString() : '00';
        const startMinValue = (filterForm.values['start_min']) ? filterForm.values['start_min'].toString() : null;
        const endDateValue = (filterForm.values['end_date']) ? filterForm.values['end_date'].toString() : null;
        const endHourValue = (filterForm.values['end_hour']) ? filterForm.values['end_hour'].toString() : null;
        const endMinValue = (filterForm.values['end_min']) ? filterForm.values['end_min'].toString() : null;
        const offsetValue = (filterForm.values['offset']) ? filterForm.values['offset'].toString() : defaultOffsetValue;
        return {
            selectedStartDate: startDateValue,
            selectedStartHour: startHourValue,
            selectedStartMin: startMinValue,
            selectedEndDate: endDateValue,
            selectedEndHour: endHourValue,
            selectedEndMin: endMinValue,
            selectedOffset: offsetValue
        }
    }
    return {
        selectedStartHour: '00',
        selectedStartMin: '00',
        selectedEndHour: '23',
        selectedEndMin: '59',
        selectedOffset: defaultOffsetValue
    }
};

DateRangeTimeFilter.propTypes = {
    addField: PropTypes.bool,
    basePath: PropTypes.string,
    onSelectEndDate: PropTypes.func,
    onSelectEndTime: PropTypes.func,
    onSelectStartDate: PropTypes.func,
    onSelectStartTime: PropTypes.func,
    onSelectOffset: PropTypes.func,
    submitOnEnter: PropTypes.bool,
};

DateRangeTimeFilter.defaultProps = {
    addField: true,
    submitOnEnter: false,
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'filterForm',
        enableReinitialize: true,
        initialValues: {
            start_hour: '00',
            start_min: '00',
            end_hour: '23',
            end_min: '59'
        }
    })
);

export default enhance(DateRangeTimeFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/DateRangeTimeFilter.js